export default "__VITE_ASSET__CvfaPXSN__";